import { PixNotificationType } from "../../master/pix/models/notification.model";
import { PixNotification } from "../../master/pix/models/notification.model";

export class DetailNotification {

	pixNotificationType: PixNotificationType;
	notificationId: number;
	messageTitle: any;
	messageContent: any;
	date: string;
	buttonDescription: any;
	buttonLink: any;
	pixNotification: PixNotification

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/models/detail-notification.ts